(()=>{'use strict';
  const instances=new WeakMap();
  function mount(root){
    if(instances.has(root))return;
    const media=window.matchMedia('(prefers-reduced-motion: reduce)');
    const tabs=[...root.querySelectorAll('[data-ndp-tab]')];
    const panels=[...root.querySelectorAll('[data-ndp-panel]')];
    const motion=root.querySelector('[data-ndp-motion]');
    const stage=root.querySelector('.ndp-commerce');
    const motionAreas=[...root.querySelectorAll('.ndp-object, .ndp-case-screen')];
    const videos=[...root.querySelectorAll('[data-ndp-video]')];
    const worlds=[...root.querySelectorAll('[data-ndp-world]')];
    const listeners=[];
    let userPaused=false;
    let paused=media.matches;
    let active=true;
    let observer=null;
    let motionObserver=null;
    let stageVisible=false;
    const on=(node,type,fn)=>{node.addEventListener(type,fn);listeners.push(()=>node.removeEventListener(type,fn));};
    function syncVideos(){
      videos.forEach(video=>{
        const visible=active&&!document.hidden&&!media.matches&&stageVisible&&!paused&&!video.hidden&&!video.closest('[data-ndp-panel]')?.hidden;
        if(visible){
          if(!video.getAttribute('src')&&video.dataset.src)video.src=video.dataset.src;
          if(video.getAttribute('src')){video.muted=true;video.play().catch(()=>{});}
        }else video.pause();
      });
    }
    function syncMotion(){
      paused=userPaused||media.matches;
      root.classList.toggle('ndp-paused',paused);
      root.classList.toggle('ndp-suspended',document.hidden);
      if(motion){
        motion.setAttribute('aria-pressed',String(paused));
        motion.disabled=media.matches;
        motion.textContent=media.matches?'Reduzierte Bewegung aktiv':paused?'Animation abspielen ▶':'Animation pausieren Ⅱ';
      }
      syncVideos();
    }
    function select(index,focus){tabs.forEach((tab,i)=>{tab.setAttribute('aria-selected',String(i===index));tab.tabIndex=i===index?0:-1;});panels.forEach(panel=>{panel.hidden=panel.dataset.ndpPanel!==tabs[index].dataset.ndpTab;});syncVideos();if(focus)tabs[index].focus();}
    tabs.forEach((tab,index)=>{on(tab,'click',()=>select(index,false));on(tab,'keydown',event=>{let next=index;if(event.key==='ArrowRight')next=(index+1)%tabs.length;else if(event.key==='ArrowLeft')next=(index-1+tabs.length)%tabs.length;else if(event.key==='Home')next=0;else if(event.key==='End')next=tabs.length-1;else return;event.preventDefault();select(next,true);});});
    if(motion)on(motion,'click',()=>{if(media.matches)return;userPaused=!userPaused;syncMotion();});
    worlds.forEach(button=>on(button,'click',()=>{worlds.forEach(item=>item.setAttribute('aria-pressed',String(item===button)));videos.forEach(video=>{video.hidden=video.dataset.ndpVideo!==button.dataset.ndpWorld;});syncVideos();}));
    motionAreas.forEach(area=>area.classList.add('ndp-motion-offscreen'));
    if('IntersectionObserver'in window){
      motionObserver=new IntersectionObserver(entries=>{
        if(!active)return;
        entries.forEach(entry=>{
          entry.target.classList.toggle('ndp-motion-offscreen',!entry.isIntersecting);
          if(entry.target===stage)stageVisible=entry.isIntersecting;
        });
        syncVideos();
      },{threshold:.01});
      motionAreas.forEach(area=>motionObserver.observe(area));
      root.classList.add('ndp-motion-ready');
    }
    on(document,'visibilitychange',syncMotion);
    const onMedia=()=>syncMotion();
    if(media.addEventListener){media.addEventListener('change',onMedia);listeners.push(()=>media.removeEventListener('change',onMedia));}
    else{media.addListener(onMedia);listeners.push(()=>media.removeListener(onMedia));}
    syncMotion();
    if('IntersectionObserver'in window&&!media.matches){observer=new IntersectionObserver(entries=>{if(!active)return;entries.forEach(entry=>{if(entry.isIntersecting){entry.target.classList.add('is-visible');observer.unobserve(entry.target);}});},{threshold:.08,rootMargin:'0px 0px 30px 0px'});root.classList.add('ndp-enhanced');root.querySelectorAll('.ndp-reveal').forEach(node=>observer.observe(node));}
    instances.set(root,()=>{
      active=false;
      observer?.disconnect();
      motionObserver?.disconnect();
      videos.forEach(video=>video.pause());
      listeners.forEach(dispose=>dispose());
      root.classList.remove('ndp-motion-ready','ndp-suspended','ndp-paused','ndp-enhanced');
      motionAreas.forEach(area=>area.classList.remove('ndp-motion-offscreen'));
      instances.delete(root);
    });
  }
  function scan(scope){if(scope.matches?.('[data-digital-products]'))mount(scope);scope.querySelectorAll?.('[data-digital-products]').forEach(mount);}
  scan(document);
  document.addEventListener('shopify:section:load',event=>scan(event.target));
  document.addEventListener('shopify:section:unload',event=>{const roots=event.target.matches?.('[data-digital-products]')?[event.target]:[...event.target.querySelectorAll('[data-digital-products]')];roots.forEach(root=>instances.get(root)?.());});
})();
